<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :tabs="tabs"
    :selectedIndex="selectedIndex"
    :baseView="baseView"
    :key="pageKey"
    :formsConfig="formsConfig"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :hot-key-create-path="`/customer/create`"
    :hot-key-grid-tab-index="-1"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        title="Customer"
        :baseView="baseView"
        :primaryLabel="model.Name"
        :secondaryLabel="baseView.id"
        recordType="Customer"
      />
    </template>

    <div class="css-v2 gc-master-screen">
      <DxToolbar class="view-toolbar">
        <DxItem
          widget="dxForm"
          location="before"
          :options="{
            formData: model,
            items: toolbarFormItems,
            validationGroup: 'toolbarForm',
            labelLocation: 'left',
            disabled: baseView.mode == 'review' ? true : false,
            onContentReady: onToolbarFormContentReady,
          }"
          locate-in-menu="auto"
          :disabled="baseView.mode == 'review' ? true : false"
        ></DxItem>

        <DxItem
          widget="dxForm"
          location="after"
          :options="{
            formData: model,
            items: toolbarActiveItems,
            validationGroup: 'toolbarActive',
            labelLocation: 'left',
            disabled: baseView.mode == 'review' ? true : false,
          }"
          locate-in-menu="after"
          :disabled="baseView.mode == 'review' ? true : false"
        ></DxItem>

        <!-- <DxItem
        :options="toolbar.status"
        location="after"
        locate-in-menu="after"
        widget="dxSwitch"
        ref="status"
        :disabled="baseView.mode == 'review' ? true : false"
      />-->

        <DxItem
          :options="toolbar.audit"
          location="after"
          locate-in-menu="auto"
          widget="dxButton"
          v-if="baseView.mode == 'review'"
        >
          <DxRequiredRule message="Email is required" />
        </DxItem>

        <DxItem
          :options="toolbar.edit"
          location="after"
          locate-in-menu="auto"
          widget="dxButton"
          v-if="baseView.mode == 'review'"
          :visible="formsConfig.editableOption"
        />

        <DxItem
          :options="toolbar.save"
          location="after"
          locate-in-menu="auto"
          widget="dxButton"
          v-if="baseView.mode != 'review'"
        />

        <DxItem
          :options="toolbar.ellipsis"
          location="after"
          locate-in-menu="auto"
          widget="dxDropDownButton"
          v-if="baseView.mode != 'create' && model.Inactive"
        />
      </DxToolbar>
      <!-- display the model data - DEBUGGING
    <div>{{JSON.stringify(model)}}</div>-->
      <div class="view-card responsive-paddings">
        <form v-if="loadingCompleted">
          <DxForm
            :form-data.sync="model"
            :read-only="false"
            :show-colon-after-label="false"
            :show-required-mark="false"
            :show-validation-summary="false"
            :validation-group="formsConfig.validationGroup"
            label-location="left"
            :customizeItem="customizeItem"
            :items="items.items"
            :ref="'customer-details'"
            @content-ready="onContentReady"
          >
            <template #currencyTemplate="{ data }">
              <div class="custom-auto-complete">
                <span class="auto-complete-primary">{{
                  data.Description
                }}</span>
                <span class="auto-complete-secondary">{{ data.Code }}</span>
              </div>
            </template>
            <template #billToCustomerTemplate="{ data }">
              <div class="custom-auto-complete">
                <span class="auto-complete-primary">{{ data.Name }}</span>
                <span class="auto-complete-secondary">{{ data.Code }}</span>
              </div>
            </template>
            <template #customerTypeTemplate="{ data }">
              <div class="custom-auto-complete">
                <span class="auto-complete-primary">{{
                  data.Description
                }}</span>
                <span class="auto-complete-secondary">{{ data.Code }}</span>
              </div>
            </template>
            <template #customerGroupTemplate="{ data }">
              <div class="custom-auto-complete">
                <span class="auto-complete-primary">{{
                  data.Description
                }}</span>
                <span class="auto-complete-secondary">{{ data.Code }}</span>
              </div>
            </template>
            <template #salesRepTemplate="{ data }">
              <div class="custom-auto-complete">
                <span class="auto-complete-primary"
                  >{{ data.FirstName }} {{ data.Surname }}</span
                >
                <span class="auto-complete-secondary">{{ data.Code }}</span>
              </div>
            </template>
            <template #customerReportingTemplate="{ data }">
              <div class="custom-auto-complete">
                <span class="auto-complete-primary">{{ data.Name }}</span>
                <span class="auto-complete-secondary">{{ data.Code }}</span>
              </div>
            </template>
          </DxForm>
        </form>
      </div>
    </div>

    <GcPopupCustomerStatement
      :setVisible="CustomerStatementVisible"
      :hidden="customerStatementOnHidden"
      :showLoading="showLoading"
      :dataObj="model"
      v-if="CustomerStatementVisible"
    />
  </gc-main-layout>
</template>

<script>
import BaseViewMixin from "../../v1/_mixins/base.view";
import CustomerTabsMixin from "@/_mixins/customer-tabs.mixin";
import { CurrencyService } from "../../_services/api/accounts/currency.service";
import { ForeignCurrencyService } from "../../_services/api/settings/accounting/foreign-currency.service";
import { SalesRepresentativeService } from "../../_services/api/sales/sales-rep.service";
import { DxCustomRule } from "devextreme-vue/validator";
import { DxSwitch } from "devextreme-vue/switch";
import validationEngine from "devextreme/ui/validation_engine";
import { CustomerService } from "../../_services/api/customers/customer.service";
import { CustomerGroupService } from "../../_services/api/settings/customers/customer-group.service";
import { CustomerTypeService } from "../../_services/api/settings/customers/customer-type.service";
import { CustomerRegionService } from "../../_services/api/settings/customers/customer-region.service";
import { CustomerMarketService } from "../../_services/api/settings/customers/customer-market.service";
import { CustomerReportingGroup1Service } from "../../_services/api/settings/customers/customer-reporting-group-1.service";
import { CustomerReportingGroup2Service } from "../../_services/api/settings/customers/customer-reporting-group-2.service";
import { CustomerReportingGroup3Service } from "../../_services/api/settings/customers/customer-reporting-group-3.service";
import { CustomerSubRegionService } from "../../_services/api/settings/customers/customer-sub-region.service";
import { FeatureStorage } from "../../_services/storage";
import GcPopupCustomerStatement from "../../popups/customers/gc-popup-customer-statement.vue";

export default {
  props: {},
  mixins: [BaseViewMixin, CustomerTabsMixin],
  // eslint-disable-next-line vue/no-unused-components
  components: { DxCustomRule, DxSwitch, GcPopupCustomerStatement },
  async created() {
    this.intialize();
  },
  mounted() {
    this.selectedIndex = 1;
  },
  updated() {
    if (this.loadingCompleted) {
      validationEngine.validateGroup(this.formsConfig.validationGroup);
      validationEngine.validateGroup("toolbarForm");
      validationEngine.validateGroup("toolbarActive");
    }
  },
  data() {
    return {
      model: {
        Code: "",
        Name: "",
        CreditLimit: "",
        StopCredit: "",
        StatementMethod: "",
        Gst: "",
        TaxNo: "",
        Wet: "",
        Abn: "",
        Acn: "",
        Inactive: "",
        CurrencyCode: "",
        CurrencyName: "",
        BillToCustomerCode: "",
        TermCalculation: "",
        Terms: 0,
        CustomerTypeCode: "",
        CustomerGroupCode: "",
        SalesRepresentativeCode: "",
        MailAddressCompanyName: "",
        MailAddressStreetLine1: "",
        MailAddressStreetLine2: "",
        MailAddressSuburb: "",
        MailAddressState: "",
        MailAddressPostcode: "",
        MailAddressCountry: "",
        Phone1: "",
        Status: "A",
        CustomerCreditor: "",
        CustomerSelfRef: "",
        CustomerMarketCode: undefined,
        CustomerReportingGroup1Code: undefined,
        CustomerReportingGroup2Code: undefined,
        CustomerReportingGroup3Code: undefined,
        CustomerRegionCode: undefined,
        CustomerSubRegionCode: undefined,
        IntraCompanyCustomer: "",
      },
      allowSetInActive: false,
      CustomerStatementVisible: false,
      TermDaysDisabled: false,
      // loadingCompleted: false,
      ToolbarFormComponent: undefined,
    };
  },
  computed: {
    toolbarFormItems() {
      return [
        {
          dataField: "Name",
          width: 500,
          label: { text: "Name", visible: false },
          editorOptions: {
            maxLength: 100,
            placeholder: "Customer Name",
          },
          validationRules: [
            {
              type: "required",
              message: "Name is required",
            },
          ],
        },
      ];
    },
    items() {
      return {
        items: [
          {
            itemType: "group",
            caption: "",
            colCount: 3,
            items: [
              {
                itemType: "group",
                items: this.parseFormColumns([
                  {
                    dataField: "MailAddressStreetLine1",
                    gcLabel: "Street Line 1",
                    gcType: "String",
                    editorType: "dxTextBox",
                    editorOptions: {
                      maxLength: 50,
                    },
                  },
                  {
                    dataField: "MailAddressStreetLine2",
                    gcLabel: "Street Line 2",
                    gcType: "String",
                    editorType: "dxTextBox",
                    editorOptions: {
                      maxLength: 50,
                    },
                  },
                  {
                    dataField: "MailAddressSuburb",
                    gcLabel: "Suburb",
                    gcType: "String",
                    editorType: "dxTextBox",
                    editorOptions: {
                      maxLength: 50,
                    },
                  },
                  {
                    dataField: "MailAddressState",
                    gcLabel: "State",
                    gcType: "String",
                    editorType: "dxTextBox",
                    editorOptions: {
                      maxLength: 100,
                    },
                  },

                  {
                    dataField: "MailAddressPostcode",
                    gcLabel: "Postcode",
                    gcType: "String",
                    editorType: "dxTextBox",
                    editorOptions: {
                      maxLength: 20,
                    },
                  },

                  {
                    dataField: "MailAddressCountry",
                    gcLabel: "Country",
                    gcType: "String",
                    editorType: "dxTextBox",
                    editorOptions: {
                      maxLength: 30,
                    },
                  },

                  {
                    dataField: "Phone1",
                    gcLabel: "Phone",
                    gcType: "String",
                    editorType: "dxTextBox",
                    editorOptions: {
                      maxLength: 20,
                    },
                  },

                  {
                    dataField: "CustomerCreditor",
                    gcLabel: "Customer Creditor",
                    gcType: "String",
                    editorType: "dxTextBox",
                    editorOptions: {
                      maxLength: 20,
                    },
                  },

                  {
                    dataField: "CustomerSelfRef",
                    gcLabel: "Customer Self Ref",
                    gcType: "String",
                    editorType: "dxTextBox",
                    editorOptions: {
                      maxLength: 20,
                    },
                  },
                  {
                    dataField: "IntraCompanyCustomer",
                    gcLabel: "Intra Company",
                    gcType: "Boolean",
                  },
                ]),
              },
              {
                itemType: "group",
                caption: "",
                items: this.parseFormColumns([
                  {
                    dataField:
                      this.baseView.mode == "review"
                        ? "CurrencyDescription"
                        : "CurrencyCode",
                    id: "currency-selectBox",
                    gcLabel: "Currency",
                    gcType: "String",
                    editorType:
                      this.baseView.mode == "review"
                        ? "dxTextBox"
                        : "dxSelectBox",
                    editorOptions: {
                      dataSource: CurrencyService.dataSourceConfig(
                        "api/Currency",
                        {
                          select: ["Code", "Description", "RecordId"],
                          filter: [["Inactive", "=", "N"]],
                          key: "RecordId",
                        },
                      ),
                      itemTemplate: "currencyTemplate",
                      valueExpr: "Code",
                      displayExpr: "Description",
                      searchExpr: ["Code", "Description"],
                      searchMode: "contains",
                      showClearButton: true,
                      // onItemClick: this.CurrencyChange,
                      searchEnabled: true,
                      readOnly: this.baseView.mode == "edit",
                    },
                    validationRules: [
                      {
                        type: "required",
                        message: "Currency is required",
                      },
                      {
                        type: "async",
                        validationCallback: this.currencyExistsRuleCallback,
                        message: "Currency does not exist",
                      },
                    ],
                  },

                  {
                    dataField:
                      this.baseView.mode == "review"
                        ? "BillToCustomerName"
                        : "BillToCustomerCode",
                    id: "bill-to-customer-selectBox",
                    gcLabel: "Bill To Customer",
                    gcType: "String",
                    editorType:
                      this.baseView.mode == "review"
                        ? "dxTextBox"
                        : "dxSelectBox",
                    editorOptions: {
                      dataSource: CustomerService.dataSourceConfig(
                        "api/Customer",
                        {
                          select: ["Code", "Name"],
                          filter: [
                            ["Inactive", "=", "N"],
                            ["CurrencyCode", "=", this.model.CurrencyCode],
                          ],
                          sort: [{ selector: "Name", asc: true }],
                        },
                      ),
                      itemTemplate: "billToCustomerTemplate",
                      valueExpr: "Code",
                      displayExpr: "Name",
                      searchExpr: ["Code", "Name"],
                      searchMode: "contains",
                      showClearButton: true,
                      // onItemClick: this.CurrencyChange,
                      searchEnabled: true,
                    },
                    validationRules:
                      this.baseView.mode != "create"
                        ? [
                            {
                              type: "required",
                              message: "Bill To Customer is required",
                            },
                            {
                              type: "async",
                              validationCallback: this.billToExistsRuleCallback,
                              message: "Bill To does not exist",
                            },
                          ]
                        : [],
                  },
                  {
                    dataField: "TermCalculation",
                    gcLabel: "Terms Method",
                    id: "terms-selectBox",
                    gcType: "String",
                    editorType: "dxSelectBox",
                    required: true,
                    editorOptions: {
                      onValueChanged: (e) => {
                        this.onTermChanged(e.value);
                      },
                      items: [
                        {
                          value: "ACTUAL",
                          text: "ACTUAL",
                        },
                        {
                          value: "EOW",
                          text: "EOW",
                        },
                        {
                          value: "EOM",
                          text: "EOM",
                        },
                        {
                          value: "CBD",
                          text: "CBD",
                        },
                      ],
                      valueExpr: "value",
                      displayExpr: "text",
                      showClearButton: true,
                    },
                  },
                  {
                    dataField: "Terms",
                    gcType: "Decimal-4-0",
                    gcLabel: "Terms Days",
                    readOnly: this.TermDaysDisabled,
                    editorOptions: {
                      min: 0,
                      max: 999,
                      step: 0,
                    },

                    required: true,
                  },

                  {
                    dataField: "CreditLimit",
                    gcType: "Decimal-6-2",
                    gcLabel: "Credit Limit",
                    editorOptions: {
                      min: 0,
                      max: 999999999.99,
                      step: 0,
                    },
                  },

                  // {
                  //   dataField: "StatementMethod",
                  //   gcLabel: "Statement",
                  //   id: "statement-selectBox",
                  //   gcType: "String",
                  //   editorType: "dxSelectBox",
                  //   required: true,
                  //   editorOptions: {
                  //     items: [
                  //       {
                  //         value: "Email",
                  //         text: "Email",
                  //       },
                  //       {
                  //         value: "Print",
                  //         text: "Print",
                  //       },
                  //       {
                  //         value: "None",
                  //         text: "None",
                  //       },
                  //     ],
                  //     valueExpr: "value",
                  //     displayExpr: "text",
                  //     showClearButton: true,
                  //   },
                  // },
                  {
                    itemType: "group",
                    caption: "",
                    colCount: 2,
                    gcType: "group",
                    items: [
                      {
                        dataField: "Abn",
                        gcLabel: "ABN",
                        label: {
                          text: "ABN",
                        },
                        gcType: "String",
                        editorType: "dxTextBox",
                        editorOptions: {
                          maxLength: 20,
                        },
                      },

                      {
                        dataField: "Acn",
                        gcLabel: "ACN",
                        label: {
                          text: "ACN",
                        },
                        gcType: "String",
                        editorType: "dxTextBox",
                        editorOptions: {
                          maxLength: 20,
                        },
                      },
                    ],
                  },
                  {
                    dataField: "StopCredit",
                    gcLabel: "Stop Credit",
                    gcType: "Boolean",
                  },
                  {
                    dataField: "Gst",
                    gcLabel: "GST",
                    id: "gst-selectBox",
                    gcType: "String",
                    editorType: "dxSelectBox",
                    required: true,
                    onValueChanged: this.onGstChanged,
                    editorOptions: {
                      items: [
                        {
                          value: "yes",
                          text: "Yes",
                        },
                        {
                          value: "exempt",
                          text: "Exempt",
                        },
                        {
                          value: "export",
                          text: "Export",
                        },
                      ],
                      valueExpr: "value",
                      displayExpr: "text",
                      showClearButton: true,
                    },
                  },

                  {
                    dataField: "TaxNo",
                    gcLabel: "Exemption #",
                    gcType: "String",
                    editorType: "dxTextBox",
                    validationRules:
                      // this.model.Gst == "exempt"
                      //   ? [
                      //       {
                      //         type: "required",
                      //         message: "Exemption # is required",
                      //       },
                      //       {
                      //         type: "stringLength",
                      //         min: 11,
                      //         max: 11,
                      //         message: "Exemption # must be 11 characters",
                      //         ignoreEmptyValue: true,
                      //       },
                      //     ]
                      //   :
                      [
                        {
                          type: "stringLength",
                          min: 11,
                          max: 11,
                          message: "Exemption # must be 11 characters",
                          ignoreEmptyValue: true,
                        },
                      ],
                  },

                  {
                    dataField: "Wet",
                    gcLabel: "WET",
                    id: "wet-selectBox",
                    gcType: "String",
                    editorType: "dxSelectBox",
                    required: true,
                    onValueChanged: this.onGstChanged,
                    editorOptions: {
                      items:
                        this.model.Gst == "yes"
                          ? [
                              {
                                value: "yes",
                                text: "Yes",
                              },
                              {
                                value: "exempt",
                                text: "Exempt",
                              },
                            ]
                          : [
                              {
                                value: "yes",
                                text: "Yes",
                              },
                              {
                                value: "exempt",
                                text: "Exempt",
                              },
                              {
                                value: "export",
                                text: "Export",
                              },
                            ],
                      valueExpr: "value",
                      displayExpr: "text",
                      showClearButton: true,
                      value:
                        this.model.Gst == "exempt"
                          ? "exempt"
                          : this.model.Gst == "export"
                          ? "export"
                          : this.model.Wet,
                      readOnly:
                        this.model.Gst == "exempt" || this.model.Gst == "export"
                          ? true
                          : false,
                    },
                  },
                ]),
              },
              {
                itemType: "group",
                caption: "",
                items: this.parseFormColumns([
                  {
                    dataField: "Status",
                    gcType: "String",
                    editorType: "dxSelectBox",
                    gcLabel: "Status",
                    editorOptions: {
                      editorType: "dxSelectBox",
                      items: [
                        {
                          text: "Approved",
                          value: "A",
                        },
                        {
                          text: "Enquiry",
                          value: "E",
                        },
                        {
                          text: "Pending",
                          value: "P",
                        },
                      ],
                      valueExpr: "value",
                      displayExpr: "text",
                    },
                  },
                  {
                    dataField:
                      this.baseView.mode == "review"
                        ? "CustomerTypeDescription"
                        : "CustomerTypeCode",
                    gcLabel: "Customer Type",
                    gcType: "String",
                    editorType:
                      this.baseView.mode == "review"
                        ? "dxTextBox"
                        : "dxSelectBox",
                    id: "customer-type-selectBox",
                    editorOptions: {
                      dataSource: CustomerTypeService.dataSourceConfig(
                        "api/CustomerType",
                        {
                          select: ["Code", "Description"],
                          filter: [["Inactive", "=", "N"]],
                          sort: [{ selector: "Description", asc: true }],
                        },
                      ),
                      itemTemplate: "customerTypeTemplate",
                      valueExpr: "Code",
                      displayExpr: "Description",
                      searchExpr: ["Code", "Description"],
                      searchMode: "contains",
                      showClearButton: true,
                      // onItemClick: this.CurrencyChange,
                      searchEnabled: true,
                    },
                    validationRules: [
                      {
                        type: "required",
                        message: "Customer Type is required",
                      },
                      {
                        type: "async",
                        validationCallback: this.customerTypeExistsRuleCallback,
                        message: "Customer Type does not exist",
                      },
                    ],
                  },

                  {
                    dataField:
                      this.baseView.mode == "review"
                        ? "CustomerGroupDescription"
                        : "CustomerGroupCode",
                    gcLabel: "Customer Group",
                    gcType: "String",
                    editorType:
                      this.baseView.mode == "review"
                        ? "dxTextBox"
                        : "dxSelectBox",
                    id: "customer-group-selectBox",
                    editorOptions: {
                      dataSource: CustomerGroupService.dataSourceConfig(
                        "api/CustomerGroup",
                        {
                          select: ["Code", "Description"],
                          filter: [["Inactive", "=", "N"]],
                          sort: [{ selector: "Description", asc: true }],
                        },
                      ),
                      itemTemplate: "customerGroupTemplate",
                      valueExpr: "Code",
                      displayExpr: "Description",
                      searchExpr: ["Code", "Description"],
                      searchMode: "contains",
                      showClearButton: true,
                      // onItemClick: this.CurrencyChange,
                      searchEnabled: true,
                    },
                    validationRules: [
                      {
                        type: "required",
                        message: "Customer Group is required",
                      },
                      {
                        type: "async",
                        validationCallback:
                          this.customerGroupExistsRuleCallback,
                        message: "Customer Group does not exist",
                      },
                    ],
                  },

                  {
                    dataField:
                      this.baseView.mode == "review"
                        ? "CustomerMarketDescription"
                        : "CustomerMarketCode",
                    gcLabel: "Market",
                    gcType: "String",
                    editorType:
                      this.baseView.mode == "review"
                        ? "dxTextBox"
                        : "dxSelectBox",
                    id: "customer-type-selectBox",
                    editorOptions: {
                      dataSource: CustomerMarketService.dataSourceConfig(
                        "api/CustomerMarket",
                        {
                          select: ["Code"],
                          filter: [["Inactive", "=", "N"]],
                          sort: [{ selector: "Code", asc: true }],
                        },
                      ),

                      valueExpr: "Code",
                      displayExpr: "Code",
                      searchExpr: ["Code"],
                      searchMode: "contains",
                      showClearButton: true,
                      // onItemClick: this.CurrencyChange,
                      searchEnabled: true,
                    },
                  },

                  {
                    dataField:
                      this.baseView.mode == "review"
                        ? "CustomerReportingGroup1Description"
                        : "CustomerReportingGroup1Code",
                    gcLabel: "Reporting Group 1",
                    gcType: "String",
                    editorType:
                      this.baseView.mode == "review"
                        ? "dxTextBox"
                        : "dxSelectBox",
                    id: "customer-type-selectBox",
                    editorOptions: {
                      dataSource:
                        CustomerReportingGroup1Service.dataSourceConfig(
                          "api/CustomerReportingGroup1",
                          {
                            select: ["Code", "Name"],
                            filter: [["Inactive", "=", "N"]],
                            sort: [{ selector: "Name", asc: true }],
                          },
                        ),
                      itemTemplate: "customerReportingTemplate",
                      valueExpr: "Code",
                      displayExpr: "Name",
                      searchExpr: ["Code", "Name"],
                      searchMode: "contains",
                      showClearButton: true,
                      // onItemClick: this.CurrencyChange,
                      searchEnabled: true,
                    },
                  },

                  {
                    dataField:
                      this.baseView.mode == "review"
                        ? "CustomerReportingGroup2Description"
                        : "CustomerReportingGroup2Code",
                    gcLabel: "Reporting Group 2",
                    gcType: "String",
                    editorType:
                      this.baseView.mode == "review"
                        ? "dxTextBox"
                        : "dxSelectBox",
                    id: "customer-type-selectBox",
                    editorOptions: {
                      dataSource:
                        CustomerReportingGroup2Service.dataSourceConfig(
                          "api/CustomerReportingGroup2",
                          {
                            select: ["Code", "Name"],
                            filter: [["Inactive", "=", "N"]],
                            sort: [{ selector: "Name", asc: true }],
                          },
                        ),
                      itemTemplate: "customerReportingTemplate",
                      valueExpr: "Code",
                      displayExpr: "Name",
                      searchExpr: ["Code", "Name"],
                      searchMode: "contains",
                      showClearButton: true,
                      // onItemClick: this.CurrencyChange,
                      searchEnabled: true,
                    },
                  },

                  {
                    dataField:
                      this.baseView.mode == "review"
                        ? "CustomerReportingGroup3Description"
                        : "CustomerReportingGroup3Code",
                    gcLabel: "Reporting Group 3",
                    gcType: "String",
                    editorType:
                      this.baseView.mode == "review"
                        ? "dxTextBox"
                        : "dxSelectBox",
                    id: "customer-type-selectBox",
                    editorOptions: {
                      dataSource:
                        CustomerReportingGroup3Service.dataSourceConfig(
                          "api/CustomerReportingGroup3",
                          {
                            select: ["Code", "Name"],
                            filter: [["Inactive", "=", "N"]],
                            sort: [{ selector: "Name", asc: true }],
                          },
                        ),
                      itemTemplate: "customerReportingTemplate",
                      valueExpr: "Code",
                      displayExpr: "Name",
                      searchExpr: ["Code", "Name"],
                      searchMode: "contains",
                      showClearButton: true,
                      // onItemClick: this.CurrencyChange,
                      searchEnabled: true,
                    },
                  },

                  {
                    dataField:
                      this.baseView.mode == "review"
                        ? "SalesRepresentativeFullName"
                        : "SalesRepresentativeCode",
                    gcLabel: "Sales Rep",
                    gcType: "String",
                    editorType:
                      this.baseView.mode == "review"
                        ? "dxTextBox"
                        : "dxSelectBox",
                    id: "sales-rep-selectBox",
                    editorOptions: {
                      dataSource: SalesRepresentativeService.dataSourceConfig(
                        "api/SalesRepresentative",
                        {
                          select: ["Code", "FirstName", "Surname"],
                          filter: [
                            ["Inactive", "=", "N"],
                            ["Status", "=", "A"],
                          ],
                          sort: [{ selector: "FirstName", asc: true }],
                        },
                      ),
                      itemTemplate: "salesRepTemplate",
                      valueExpr: "Code",
                      displayExpr: function (data) {
                        if (data) return data.FirstName + " " + data.Surname;
                      },
                      searchExpr: ["Code", "FirstName", "Surname"],
                      searchMode: "contains",
                      showClearButton: true,
                      searchEnabled: true,
                    },
                    validationRules: [
                      {
                        type: "async",
                        validationCallback: this.salesRepExistsRuleCallback,
                        message: "Customer Group does not exist",
                      },
                    ],
                  },

                  {
                    dataField: "CustomerRegionCode",
                    gcLabel: "Region",
                    gcType: "String",
                    editorType:
                      this.baseView.mode == "review"
                        ? "dxTextBox"
                        : "dxSelectBox",
                    id: "sales-rep-selectBox",
                    editorOptions: {
                      dataSource: CustomerRegionService.dataSourceConfig(
                        "api/CustomerRegion",
                        {
                          select: ["Code"],
                          filter: [["Inactive", "=", "N"]],
                          sort: [{ selector: "Code", asc: true }],
                        },
                      ),
                      valueExpr: "Code",
                      displayExpr: "Code",
                      searchExpr: ["Code"],
                      searchMode: "contains",
                      showClearButton: true,
                      searchEnabled: true,
                      onValueChanged: (e) => {
                        this.getDefaultSubRegion(e.value);
                      },
                    },
                    validationRules:
                      this.baseView.mode == "create"
                        ? [
                            {
                              type: "required",
                              message: "Region is required",
                            },
                          ]
                        : [],
                  },

                  {
                    dataField: "CustomerSubRegionCode",
                    gcLabel: "Sub Region",
                    gcType: "String",
                    editorType:
                      this.baseView.mode == "review"
                        ? "dxTextBox"
                        : "dxSelectBox",
                    id: "sales-rep-selectBox",
                    editorOptions: {
                      dataSource: CustomerSubRegionService.dataSourceConfig(
                        "api/CustomerSubRegion",
                        {
                          select: ["Code"],
                          filter: [
                            ["Inactive", "=", "N"],
                            "and",
                            [
                              "CustomerRegionCode",
                              "=",
                              this.model.CustomerRegionCode,
                            ],
                          ],
                          sort: [{ selector: "Code", asc: true }],
                        },
                      ),
                      valueExpr: "Code",
                      displayExpr: "Code",
                      searchExpr: ["Code"],
                      searchMode: "contains",
                      showClearButton: true,
                      searchEnabled: true,
                      readOnly: !this.model.CustomerRegionCode,
                    },
                    validationRules:
                      this.baseView.mode == "create"
                        ? [
                            {
                              type: "required",
                              message: "Sub Region is required",
                            },
                          ]
                        : [],
                  },
                ]),
              },
            ],
          },
        ],
      };
    },
    toolbarActiveItems() {
      return this.parseFormColumns([
        {
          dataField: "Inactive",
          gcType: "Boolean",
          gcLabel: "Active",
          editorOptions: {
            tabIndex: -1,
            onValueChanged: (e) => {
              this.onInActiveValueChange(e);
            },
          },
        },
      ]);
    },
    toolbar() {
      return {
        ellipsis: {
          icon: "more",
          class: "gc-dropdown-icon-button",
          stylingMode: "text",
          showArrowIcon: false,
          tabIndex: -1,
          items: [
            {
              menuText: "Invoice",
              disabled: FeatureStorage.checkPermission("Invoice", "create")
                ? false
                : true,
            },
            {
              menuText: "Credit",
              disabled: FeatureStorage.checkPermission("Invoice", "create")
                ? false
                : true,
            },
            {
              menuText: "Receipt",
              // visible: this.model.Status == "A" ? true : false,
              disabled:
                this.model.Status == "A" &&
                FeatureStorage.checkPermission("CashReceipt", "create")
                  ? false
                  : true,
            },
            {
              menuText: "Statement",
              disabled: FeatureStorage.checkPermission(
                "ReportCustomerStatement",
                "create",
              )
                ? false
                : true,
            },
            {
              menuText: "Call Log",
              disabled: FeatureStorage.checkPermission("CallLogs", "create")
                ? false
                : true,
            },
          ],
          keyExpr: "menuText",
          displayExpr: "menuText",
          dropDownOptions: { width: 150 },
          onItemClick: this.onItemClicked,
        },
        name: {
          // validationGroup: "formsData",
          value: this.model.Name,
          width: 500,
          editorType: "dxTextBox",
          editorOptions: {
            maxLength: 100,
          },
          // label: {
          //   text: "Name"
          // },
          validationRules: [
            {
              type: "required",
              message: "Name is required",
            },
          ],
        },
        status: {
          value: this.model.Inactive,
          editorType: "dxSwitch",
        },
        edit: {
          icon: "edit",
          onClick: this.editClick,
        },
        save: {
          validationGroup: "formsData",
          ref: "saveButton",
          icon: "floppy",
          tabIndex: -1,
          onClick: async (e) => {
            this.focusOutOnEditors();
            this.$logger.trackEventButtonClickSave();
            const mainForm = await validationEngine.validateGroup("formsData");
            const toolbarForm = await validationEngine.validateGroup(
              "toolbarForm",
            );
            const toolbarActive = await validationEngine.validateGroup(
              "toolbarActive",
            );

            var value = mainForm.brokenRules.concat(
              toolbarForm.brokenRules.concat(toolbarActive.brokenRules),
            );

            // this.$logger.debug("validation error ", value);

            if (
              mainForm.isValid &&
              toolbarForm.isValid &&
              toolbarActive.isValid
            ) {
              this.saveCustomerDetails(e);
            } else {
              this.addErrorMessagesFromValidationResult({
                brokenRules: value,
              });
              this.displayCustomValidationSummary();
              return;
            }
          },
        },
        audit: {
          icon: "clock",
          visible: function () {
            return this.baseView.mode != "create";
          },
          onClick: () => {
            this.displayAuditPopup(
              this.model.CreatedBy,
              this.model.DateCreated,
              this.model.ChangedBy,
              this.model.DateChanged,
            );
          },
        },
      };
    },
  },

  methods: {
    onContentReady() {
      if (this.ToolbarFormComponent) {
        setTimeout(() => {
          this.ToolbarFormComponent.instance().getEditor("Name").focus();
        }, 250);
      }
    },
    onToolbarFormContentReady(e) {
      e.component.instance().getEditor("Name").focus();
      this.ToolbarFormComponent = e.component;
    },
    customerStatementOnHidden() {
      this.CustomerStatementVisible = false;
    },
    onInActiveValueChange(e) {
      if (this.baseView.mode == "create") return;
      if (e.event && e.value == false && this.allowSetInActive == false) {
        this.model.Inactive = e.previousValue;

        this.addErrorMessagesFromValidationResult({
          brokenRules: [
            {
              message: `${this.model.Name} is associated with one or more open transactions. This customer may not be marked inactive until it is no longer associated with open transactions.`,
            },
          ],
        });
        this.displayCustomValidationSummary();
      }
    },
    onItemClicked({ itemData }) {
      if (itemData.menuText == "Credit") {
        this.$router.push({
          path: `/credit-customer/create/${this.baseView.id}`,
        });
      } else if (itemData.menuText == "Receipt") {
        this.$router.push({
          path: `/customer-receipt/create/${this.baseView.id}`,
          query: {
            from: "customer-detail",
          },
        });
      } else if (itemData.menuText == "Statement") {
        this.CustomerStatementVisible = true;
      } else if (itemData.menuText == "Call Log") {
        this.$router.push({
          path: `/call-logs/create`,
          query: {
            cus_id: this.baseView.id,
            from: "/customer/review/" + this.baseView.id,
          },
        });
      } else if (itemData.menuText == "Invoice") {
        this.$router.push({
          path: `/invoice/create/${this.baseView.id}`,
          query: {
            from: "/customer/review/" + this.baseView.id,
          },
        });
      }
    },
    customerGroupExistsRuleCallback(params) {
      return new Promise((resolve) => {
        CustomerGroupService.getByCode(params.value, {
          select: ["Inactive", "Code"],
        }).then((response) => {
          if (
            response.data.value.length > 0 &&
            response.data.value[0].Inactive == "N"
          ) {
            this.model.CustomerGroupCode = response.data.value[0].Code;
            resolve(true);
          } else {
            this.model.CustomerGroupCode = "";
            resolve(false);
          }
        });
      });
    },

    customerTypeExistsRuleCallback(params) {
      return new Promise((resolve) => {
        CustomerTypeService.getByCode(params.value, {
          select: ["Inactive", "Code"],
        }).then((response) => {
          if (
            response.data.value.length > 0 &&
            response.data.value[0].Inactive == "N"
          ) {
            this.model.CustomerTypeCode = response.data.value[0].Code;
            resolve(true);
          } else {
            this.model.CustomerTypeCode = "";
            resolve(false);
          }
        });
      });
    },

    currencyExistsRuleCallback(params) {
      return new Promise((resolve) => {
        CurrencyService.getByCode(params.value, {
          select: ["Inactive", "Code"],
        }).then((response) => {
          if (
            response.data.value.length > 0 &&
            response.data.value[0].Inactive == "N"
          ) {
            this.model.CurrencyCode = response.data.value[0].Code;
            resolve(true);
          } else {
            this.model.CurrencyCode = "";
            resolve(false);
          }
        });
      });
    },

    salesRepExistsRuleCallback(params) {
      if (!params.value)
        return new Promise((resolve) => {
          resolve(true);
        });
      return new Promise((resolve) => {
        SalesRepresentativeService.getByCode(params.value, {
          select: ["Inactive", "Code"],
        }).then((response) => {
          if (
            response.data.value.length > 0 &&
            response.data.value[0].Inactive == "N"
          ) {
            this.model.SalesRepresentativeCode = response.data.value[0].Code;
            resolve(true);
          } else {
            this.model.SalesRepresentativeCode = "";
            resolve(false);
          }
        });
      });
    },

    billToExistsRuleCallback(params) {
      return new Promise((resolve) => {
        CustomerService.getByCode(params.value).then((response) => {
          if (
            response.data.value.length > 0 &&
            (this.model.Code == response.data.value[0].Code ||
              response.data.value[0].Inactive == "N")
          ) {
            this.model.BillToCustomerCode = response.data.value[0].Code;
            resolve(true);
          } else {
            this.model.BillToCustomerCode = "";
            resolve(false);
          }
        });
      });
    },

    onGstChanged() {
      let form = this.$refs["customer-details"].instance;
      form.repaint();
    },
    onTermChanged(value) {
      if (value === "CBD") {
        this.model.Terms = 0;
      }

      this.TermDaysDisabled = value === "CBD" ? true : false;
    },
    editClick() {
      this.$router.push({
        path: `/customer/edit/${this.baseView.id}`,
      });
    },
    onStatusItemClick(e) {
      this.model.Status = e.itemData.value;
    },
    async saveCustomerDetails(e) {
      let form = this.$refs["customer-details"].instance;
      form.repaint();
      // Bug 27962: Customer - Legacy allows Sales Rep to be blank but it is required in CX
      // if (!this.model.SalesRepresentativeCode)
      //   this.model.SalesRepresentativeCode = this.getFactorByCode(95).Factorc;

      let payload = {
        Abn: this.model.Abn,
        Acn: this.model.Acn,
        BillToCustomerCode: this.model.BillToCustomerCode,
        Code: this.model.Code,
        CreditLimit: this.model.CreditLimit,
        CurrencyCode: this.model.CurrencyCode,
        CustomerGroupCode: this.model.CustomerGroupCode,
        CustomerTypeCode: this.model.CustomerTypeCode,
        Gst: this.model.Gst,
        Inactive: this.model.Inactive == true ? "N" : "Y",
        MailAddressCompanyName: this.model.MailAddressCompanyName,
        MailAddressCountry: this.model.MailAddressCountry,
        MailAddressPostcode: this.model.MailAddressPostcode,
        MailAddressState: this.model.MailAddressState,
        MailAddressStreetLine1: this.model.MailAddressStreetLine1,
        MailAddressStreetLine2: this.model.MailAddressStreetLine2,
        MailAddressSuburb: this.model.MailAddressSuburb,
        Name: this.model.Name,
        Phone1: this.model.Phone1,
        SalesRepresentativeCode: this.model.SalesRepresentativeCode
          ? this.model.SalesRepresentativeCode
          : "",
        StatementMethod: this.model.StatementMethod,
        Status: this.model.Status,
        StopCredit: this.model.StopCredit == true ? "Y" : "N",
        TaxNo: this.model.TaxNo,
        TermCalculation: this.model.TermCalculation,
        Terms: this.model.Terms,
        Wet: this.model.Wet,
        CreditorCode: this.model.CustomerCreditor,
        SelfRef: this.model.CustomerSelfRef,
        IntraCompanyCustomer:
          this.model.IntraCompanyCustomer == true ? "Y" : "N",

        MarketCode: this.model.CustomerMarketCode,
        ReportingGroup1Code: this.model.CustomerReportingGroup1Code,
        ReportingGroup2Code: this.model.CustomerReportingGroup2Code,
        ReportingGroup3Code: this.model.CustomerReportingGroup3Code,
        CustomerRegionCode: this.model.CustomerRegionCode,
        CustomerSubregionCode: this.model.CustomerSubRegionCode,
      };

      const result = await e.validationGroup.validate();
      // eslint-disable-next-line no-console
      // this.$logger.debug("broken rules array", result.brokenRules);
      if (!result.isValid) {
        this.displayValidationSummary();
        return;
      }

      this.showLoading(true);
      await CustomerService.saveCustomer(this.baseView.mode, payload)
        .then((res) => {
          this.showLoading(false);
          let newRecordSaved = false;

          if (this.baseView.mode == "create") {
            newRecordSaved = true;
            this.model.Code = res.data.Code;

            this.setIgnoreRouteChangeConfirmation();
            this.$router.push({
              path: `/customer/review/${this.model.Code}`,
            });
          }
          this.$notify(
            `Customer ${this.model.Name} saved successfully`,
            "success",
          );
          this.setIgnoreRouteChangeConfirmation();
          this.$router
            .push({
              path: `/customer/review/${this.model.Code}`,
            })
            .then(() => {
              // if (!newRecordSaved)
              this.loadingCompleted = false;
              this.model.CustomerSubRegionCode = undefined;
              this.model.CustomerRegionCode = undefined;
              this.intialize();
            });
          this.$logger.debug("response", res);
          if (newRecordSaved) this.intialize();
        })
        .catch((error) => {
          this.displayServerError(error, "Customer save failed");
        });
    },

    abnValidator(options) {
      return options.value.length == 0 || options.value.length == 11;
    },

    // exemptionValidator(options) {
    //   return this.model.Gst == "exempt" && options.value.length == 11;
    // },

    async getCustomer() {
      return CustomerService.getByCode(this.baseView.id);
    },
    backButtonFunction() {
      this.$router.push({
        path: "/customer",
      });
    },
    async intialize() {
      this.showLoading(true);
      await this.$store.dispatch(
        "screenFactors/getFactors",
        [18, 589, 322, 321, 95],
      );
      if (this.baseView.mode !== "create") {
        this.model.Code = this.baseView.id;

        await CustomerService.getActiveTransactions({
          filter: `CustomerCode eq '${this.baseView.id}'`,
          select: ["CustomerCode", "TransactionCode"],
        })
          .then((res) => {
            if (res.data.value.length == 0) this.allowSetInActive = true;
            else this.allowSetInActive = false;
          })
          .catch((err) => {
            if (err) this.allowSetInActive = false;
          });

        await CustomerService.getByCode(
          this.baseView.id,
          [
            "Code",
            "Name",
            "CreditLimit",
            "StopCredit",
            "IntraCompanyCustomer",
            "TaxNo",
            "Abn",
            "Acn",
            "Inactive",
            "Terms",
            "MailAddressCompanyName",
            "MailAddressStreetLine1",
            "MailAddressStreetLine2",
            "MailAddressSuburb",
            "MailAddressState",
            "MailAddressPostcode",
            "MailAddressCountry",
            "Phone1",
            "Status",
            "DateChanged",
            "CreatedBy",
            "ChangedBy",
            "DateCreated",
            "CreditorCode",
            "SelfRef",
            "StatementMethod",
            "Gst",
            "Wet",
            "TermCalculation",
            "BillToCustomerCode",
            "CurrencyCode",
            "CustomerTypeCode",
            "CustomerGroupCode",
            "SalesRepresentativeCode",
            "MarketCode",
            "ReportingGroup1Code",
            "ReportingGroup2Code",
            "ReportingGroup3Code",
          ],

          "Currency($select=Code,Description),BillToCustomer($select=Code,Name),SalesRepresentative($select=Code,FirstName,Surname),CustomerType($select=Code,Description),CustomerGroup($select=Code,Description),CustomerMarket($select=Code),CustomerReportingGroup1($select=Code,Name),CustomerReportingGroup2($select=Code,Name),CustomerReportingGroup3($select=Code,Name)",
        ).then(async (response) => {
          if (response.data.value.length > 0) {
            this.model.Code = response.data.value[0].Code;
            this.model.Name = response.data.value[0].Name;
            this.model.CreditLimit = response.data.value[0].CreditLimit;
            this.model.StopCredit =
              response.data.value[0].StopCredit == "Y" ? true : false;
            this.model.IntraCompanyCustomer =
              response.data.value[0].IntraCompanyCustomer == "Y" ? true : false;

            this.model.TaxNo = response.data.value[0].TaxNo;
            this.model.Abn = response.data.value[0].Abn;
            this.model.Acn = response.data.value[0].Acn;
            this.model.Inactive =
              response.data.value[0].Inactive == "N" ? true : false;
            this.model.Terms = response.data.value[0].Terms;
            this.model.MailAddressCompanyName =
              response.data.value[0].MailAddressCompanyName;
            this.model.MailAddressStreetLine1 =
              response.data.value[0].MailAddressStreetLine1;
            this.model.MailAddressStreetLine2 =
              response.data.value[0].MailAddressStreetLine2;
            this.model.MailAddressSuburb =
              response.data.value[0].MailAddressSuburb;
            this.model.MailAddressState =
              response.data.value[0].MailAddressState;
            this.model.MailAddressPostcode =
              response.data.value[0].MailAddressPostcode;
            this.model.MailAddressCountry =
              response.data.value[0].MailAddressCountry;
            this.model.Phone1 = response.data.value[0].Phone1;
            this.model.Status = response.data.value[0].Status;
            this.model.DateChanged = response.data.value[0].DateChanged;
            this.model.CreatedBy = response.data.value[0].CreatedBy;
            this.model.ChangedBy = response.data.value[0].ChangedBy;
            this.model.DateCreated = response.data.value[0].DateCreated;

            this.model.CustomerCreditor = response.data.value[0].CreditorCode;
            this.model.CustomerSelfRef = response.data.value[0].SelfRef;

            // select boxes
            this.model.StatementMethod =
              response.data.value[0].StatementMethod.toLowerCase() == "print"
                ? "Print"
                : response.data.value[0].StatementMethod.toLowerCase() == "none"
                ? "None"
                : "Email";
            this.model.Gst = response.data.value[0].Gst.toLowerCase();
            this.model.Wet = response.data.value[0].Wet.toLowerCase();
            this.model.TermCalculation =
              response.data.value[0].TermCalculation.toUpperCase();
            this.TermDaysDisabled =
              response.data.value[0].TermCalculation.toUpperCase() === "CBD";
            // lookups
            this.model.BillToCustomerCode =
              response.data.value[0].BillToCustomerCode;
            this.model.BillToCustomerName =
              response.data.value[0].BillToCustomer.Name;

            this.model.CurrencyCode = response.data.value[0].CurrencyCode;
            this.model.CurrencyDescription =
              response.data.value[0].Currency.Description;

            this.model.CustomerTypeCode =
              response.data.value[0].CustomerTypeCode;
            this.model.CustomerTypeDescription =
              response.data.value[0].CustomerType.Description;

            this.model.CustomerGroupCode =
              response.data.value[0].CustomerGroupCode;
            this.model.CustomerGroupDescription =
              response.data.value[0].CustomerGroup.Description;

            if (response.data.value[0].SalesRepresentative != null) {
              this.model.SalesRepresentativeCode =
                response.data.value[0].SalesRepresentativeCode;
              this.model.SalesRepresentativeFullName =
                response.data.value[0].SalesRepresentative.FirstName +
                " " +
                response.data.value[0].SalesRepresentative.Surname;
            }

            this.model.CustomerMarketCode = response.data.value[0].MarketCode;
            this.model.CustomerMarketDescription =
              response.data.value[0].CustomerMarket.Code;

            this.model.CustomerReportingGroup1Code =
              response.data.value[0].ReportingGroup1Code;
            this.model.CustomerReportingGroup1Description =
              response.data.value[0].CustomerReportingGroup1.Name;

            this.model.CustomerReportingGroup2Code =
              response.data.value[0].ReportingGroup2Code;
            this.model.CustomerReportingGroup2Description =
              response.data.value[0].CustomerReportingGroup2.Name;

            this.model.CustomerReportingGroup3Code =
              response.data.value[0].ReportingGroup3Code;
            this.model.CustomerReportingGroup3Description =
              response.data.value[0].CustomerReportingGroup3.Name;

            this.refreshView();
            this.loadingCompleted = true;
            this.showLoading(false);
          } else {
            this.loadingCompleted = true;
            this.refreshView();
            this.showLoading(false);
          }
        });
      }
      if (this.baseView.mode == "create") {
        this.model.Abn = undefined;
        this.model.CreditLimit = 0.0;
        this.model.StatementMethod = "Email";
        this.model.Gst = "yes";
        this.model.Wet = "exempt";
        this.model.Inactive = true;
        this.model.TermCalculation = this.getFactorByCode(589).Factorc;
        this.model.Terms = 0;
        this.model.CustomerTypeCode = this.getFactorByCode(322).Factorc;
        this.model.CustomerGroupCode = this.getFactorByCode(321).Factorc;
        this.model.SalesRepresentativeCode = this.getFactorByCode(95).Factorc;

        let res = await ForeignCurrencyService.getDefaultCurrecy({
          select: ["IsDefault", "Inactive", "CurrencyCode"],
        });
        this.model.CurrencyCode = res.data.value[0].CurrencyCode;

        await CustomerMarketService.getDefault({
          select: ["Code", "IsDefault"],
        }).then((res) => {
          this.model.CustomerMarketCode = res.data.value[0].Code;
        });

        await CustomerReportingGroup1Service.getDefault({
          select: ["Code", "IsDefault"],
        }).then((res) => {
          this.model.CustomerReportingGroup1Code = res.data.value[0].Code;
        });

        await CustomerReportingGroup2Service.getDefault({
          select: ["Code", "IsDefault"],
        }).then((res) => {
          this.model.CustomerReportingGroup2Code = res.data.value[0].Code;
        });

        await CustomerReportingGroup3Service.getDefault({
          select: ["Code", "IsDefault"],
        }).then((res) => {
          this.model.CustomerReportingGroup3Code = res.data.value[0].Code;
        });

        await CustomerRegionService.getDefault({
          select: ["Code", "IsDefault"],
        }).then((res) => {
          if (res.data.value.length > 0)
            this.model.CustomerRegionCode = res.data.value[0].Code;
        });

        if (this.model.CustomerRegionCode) {
          this.getDefaultSubRegion(this.model.CustomerRegionCode);
        }

        this.loadingCompleted = true;
        this.showLoading(false);
      }
    },
    async getDefaultSubRegion(CustomerRegionCode) {
      if (CustomerRegionCode)
        await CustomerSubRegionService.getDefaultByRegion(CustomerRegionCode, {
          select: ["Code", "IsDefault", "CustomerRegionCode"],
        }).then((res) => {
          if (res.data.value.length > 0)
            this.model.CustomerSubRegionCode = res.data.value[0].Code;
        });
      else this.model.CustomerSubRegionCode = undefined;
    },
  },
  watch: {
    $route(to) {
      if (to.path == "/customer/create") {
        location.reload();
      }
    },
  },
};
</script>
